import { getRequest, postRequest } from './api'

// Work order screen: every file attached to the work order.
export async function list(workOrderID) {
  return getRequest(`proposalFile/get-list/${workOrderID || 0}`)
}

// Proposal screen: only the files of this proposal. A proposal that is not saved
// yet (id 0) has no files - the old behaviour of falling back to "the last opened
// work order" is exactly what showed foreign images on a new proposal.
export async function listByProposal(proposalID) {
  if (!proposalID || proposalID === '0') {
    return { items: [] }
  }
  return getRequest(`proposalFile/get-list-by-proposal/${proposalID}`)
}

export async function find(id) {
  return getRequest(`proposalFile/edit/${id}`)
}

export async function save(values) {
  return postRequest(`proposalFile/save`, values)
}

export function remove(values) {
  return postRequest(`proposalFile/delete`, values)
}
